import { Injectable } from '@angular/core';

import { StatsigService } from '../statsig.service';

export enum PLATFORM_FEATURE_FLAGS {
  MINIMUM_BROWSER_CHECK_ENABLED = 'minimum_browser_check_enabled',
  FE_FV_TYPEAHEAD_ENABLED = 'fe-typeahead-enabled',
  FE_CARDS_TYPEAHEAD_ENABLED = 'fe-cards-typeahead-enabled',
  ENTITY_TYPESAHEAD_ENABLED = 'entity-typeahead-search-enabled',
  FP_PERSONA_SURVEY_ENABLED = 'fp-persona-survey-enabled',
  FP_FILTERS_PERSISTENCE_ENABLED = 'fe-platform-filters-persistence-enabled',
  FP_GROUP_HEADER_ENABLED = 'fp-group-header-enabled',
  PHX_OMNISEARCH_ENABLED = 'phx-omnisearch-enabled',
  FP_SORT_CONSISTENCY_ENABLED = 'fp-sort-consistency-enabled',
  PHX_OMNIFILTER_ENABLED = 'phx-omnifilter-enabled',
  HIDE_SIDEBAR_ON_FORM_PAGES = 'hide-sidebar-on-form-page',
  PHX_FV_LIVE_PAGE_OMNIFILTER_ENABLED = 'phx-fv-live-page-omnifilter-enabled',
  FP_DEVICES_PHX_MIGRATION_ENABLED = 'fp-devices-phx-migration-enabled',
  FP_QUICK_LINKS_SEPARATION_ENABLED = 'fp-quick-links-separation-enabled',
  PHX_FUEL_MIGRATION_ENABLED = 'phx-fuel-migration-enabled',
}

@Injectable({ providedIn: 'root' })
export class PlatformFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isMinimumBrowserCheckEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.MINIMUM_BROWSER_CHECK_ENABLED);
  }

  public isFETypeaheadEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FE_FV_TYPEAHEAD_ENABLED);
  }

  public isFECardsTypeaheadEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FE_CARDS_TYPEAHEAD_ENABLED);
  }

  public isPersonaSurveyEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_PERSONA_SURVEY_ENABLED);
  }

  public isEntityTypeaheadEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.ENTITY_TYPESAHEAD_ENABLED);
  }

  public isAdminGroupHeaderEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_GROUP_HEADER_ENABLED);
  }

  public isFiltersPersistenceEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_FILTERS_PERSISTENCE_ENABLED);
  }

  public isPhxOmnisearchEnabled(): boolean {
    // Adding extra checks to prevent errors in unit tests because StatsigService is not mocked there.
    // TODO: Revisit this to see how we can avoid these checks
    if (!this.statsigService || typeof this.statsigService.evaluateGate !== 'function') {
      return false;
    }
    try {
      return !!(this.statsigService as any).evaluateGate(PLATFORM_FEATURE_FLAGS.PHX_OMNISEARCH_ENABLED);
    } catch {
      return false;
    }
  }

  public isSortConsistencyEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_SORT_CONSISTENCY_ENABLED);
  }

  public isPhxOmnifilterEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.PHX_OMNIFILTER_ENABLED);
  }

  public shouldHideSidebarOnFormPages(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.HIDE_SIDEBAR_ON_FORM_PAGES);
  }

  public isPhxFvLivePageOmnifilterEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.PHX_FV_LIVE_PAGE_OMNIFILTER_ENABLED);
  }

  public isDeviceExperiencePhxMigrationEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_DEVICES_PHX_MIGRATION_ENABLED);
  }

  public isQuickLinksSeparationEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.FP_QUICK_LINKS_SEPARATION_ENABLED);
  }


  public isPhxFuelMigrationEnabled(): boolean {
    return this.statsigService.evaluateGate(PLATFORM_FEATURE_FLAGS.PHX_FUEL_MIGRATION_ENABLED);
  }
}
